import * as React from "react";
import { SVGProps } from "react";

const SvgTenDiamonds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 285 399"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M273.6.7H11.8S.8 1 .8 15.5v367.6c0 14.5 11 14.8 11 14.8h261.9s11-.3 11-14.8V15.5C284.6 1 273.6.7 273.6.7Z"
      fill="#fff"
    />
    <mask
      id="ten-diamonds_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={215}
      width={285}
      height={183}
    >
      <path
        d="M168.2 215.1c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V215.1H168.2Z"
        fill="url(#ten-diamonds_svg__a)"
      />
    </mask>
    <g mask="url(#ten-diamonds_svg__b)">
      <path
        d="M168.2 215.1c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V215.1H168.2Z"
        fill="url(#ten-diamonds_svg__c)"
      />
    </g>
    <mask
      id="ten-diamonds_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={285}
      height={199}
    >
      <path
        d="M.8 198.9h71.7c68.8 0 137.7 0 206.5.1h5.7V15.5c0-14.5-11-14.8-11-14.8H11.8S.8 1 .8 15.5V198.9Z"
        fill="url(#ten-diamonds_svg__d)"
      />
    </mask>
    <g mask="url(#ten-diamonds_svg__e)">
      <path
        d="M.8 198.9h71.7c68.8 0 137.7 0 206.5.1h5.7V15.5c0-14.5-11-14.8-11-14.8H11.8S.8 1 .8 15.5V198.9Z"
        fill="url(#ten-diamonds_svg__f)"
      />
    </g>
    <mask
      id="ten-diamonds_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={6}
      y={0}
      width={279}
      height={399}
    >
      <path
        d="M284.1 15.5v367.2c0 14.5-11 14.8-11 14.8H11s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V15.5c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#ten-diamonds_svg__g)"
      />
    </mask>
    <g mask="url(#ten-diamonds_svg__h)">
      <path
        d="M284.1 15.5v367.2c0 14.5-11 14.8-11 14.8H11s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V15.5c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#ten-diamonds_svg__i)"
      />
    </g>
    <mask
      id="ten-diamonds_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M1.4 383.2V16c0-14.5 11-14.8 11-14.8h262.1s2.4.1 4.9 1.6C276.6.7 273.6.6 273.6.6H11.8S.8.9.8 15.4V383.1c0 14.5 11 14.8 11 14.8h.6c0 .1-11-.2-11-14.7Z"
        fill="url(#ten-diamonds_svg__j)"
      />
    </mask>
    <g mask="url(#ten-diamonds_svg__k)">
      <path
        d="M1.4 383.2V16c0-14.5 11-14.8 11-14.8h262.1s2.4.1 4.9 1.6C276.6.7 273.6.6 273.6.6H11.8S.8.9.8 15.4V383.1c0 14.5 11 14.8 11 14.8h.6c0 .1-11-.2-11-14.7Z"
        fill="url(#ten-diamonds_svg__l)"
      />
      <mask
        id="ten-diamonds_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={29}
        width={2}
        height={343}
      >
        <path
          d="M.8 29.4V372l.6-2.1V35.6c-.2-2.1-.4-4.2-.6-6.2Z"
          fill="url(#ten-diamonds_svg__m)"
        />
      </mask>
      <g mask="url(#ten-diamonds_svg__n)">
        <path
          d="M.8 29.4V372l.6-2.1V35.6c-.2-2.1-.4-4.2-.6-6.2Z"
          fill="url(#ten-diamonds_svg__o)"
        />
      </g>
    </g>
    <path
      d="M42.3 75c-7.2-4-12.9-16.1-13.1-16.4-.2.4-5.9 12.5-13.1 16.4 7.2 4 12.9 16.1 13.1 16.4.1-.4 5.9-12.5 13.1-16.4ZM21.9 45.8c0 1 .1 1.7.2 2.2.1.5.3.9.6 1.2.3.3.7.6 1.2.7.5.2 1.2.3 2 .4.8.1 1.8.2 3.1.2v1.8H10.5v-1.8c1.9-.1 3.2-.2 4-.3.8-.1 1.4-.4 1.8-.6.4-.3.7-.7.9-1.2.2-.5.3-1.4.3-2.5V25.6c0-.7-.1-1.2-.4-1.5-.2-.3-.6-.5-1-.5-.5 0-1.3.3-2.3.8-1 .6-2.2 1.3-3.7 2.3L9 24.8l11.7-7h1.4c-.1 1.6-.2 3.8-.2 6.7v21.3ZM38.1 52.7c-3.6 0-6.3-1.4-8.1-4.3-1.8-2.8-2.6-7.2-2.6-12.9 0-3.1.3-5.7.8-8 .5-2.2 1.3-4.1 2.3-5.6 1-1.5 2.2-2.5 3.5-3.2 1.4-.7 2.9-1.1 4.5-1.1 3.7 0 6.4 1.4 8.2 4.2 1.8 2.8 2.7 7.1 2.7 12.8 0 5.9-1 10.4-2.9 13.4-1.9 3.2-4.7 4.7-8.4 4.7Zm-5.8-17.9c0 5.5.5 9.5 1.5 12 1 2.6 2.6 3.8 4.7 3.8 2 0 3.5-1.2 4.5-3.6 1-2.4 1.5-6.1 1.5-11.2 0-3.8-.2-7-.8-9.3-.5-2.4-1.2-4.1-2.1-5.1-.9-1-2-1.6-3.2-1.6-1.2 0-2.1.3-2.9 1-.8.7-1.4 1.7-1.9 3s-.8 2.9-1 4.7c-.2 1.8-.3 3.9-.3 6.3ZM243.9 322.8c7.2 4 12.9 16.1 13.1 16.4.2-.4 5.9-12.5 13.1-16.4-7.2-4-12.9-16.1-13.1-16.4-.1.4-5.9 12.4-13.1 16.4ZM264.3 352c0-1-.1-1.7-.2-2.2-.1-.5-.3-.9-.6-1.2-.3-.3-.7-.6-1.2-.7-.5-.2-1.2-.3-2-.4-.8-.1-1.8-.2-3.1-.2v-1.8h18.5v1.8c-1.9.1-3.2.2-4 .3-.8.1-1.4.4-1.8.6-.4.3-.7.7-.9 1.2-.2.5-.3 1.4-.3 2.5v20.3c0 .7.1 1.2.4 1.5.2.3.6.5 1 .5.5 0 1.3-.3 2.3-.8 1-.6 2.2-1.3 3.7-2.3l1.1 1.9-11.7 7h-1.4c.1-1.6.1-3.8.1-6.7V352h.1ZM248.1 345.1c3.6 0 6.3 1.4 8.1 4.3 1.8 2.8 2.6 7.2 2.6 12.9 0 3.1-.3 5.7-.8 8-.5 2.2-1.3 4.1-2.3 5.6-1 1.5-2.2 2.5-3.5 3.2-1.4.7-2.9 1.1-4.5 1.1-3.7 0-6.4-1.4-8.2-4.2-1.8-2.8-2.7-7.1-2.7-12.8 0-5.9 1-10.4 2.9-13.4 1.9-3.2 4.7-4.7 8.4-4.7Zm5.8 17.9c0-5.5-.5-9.5-1.5-12-1-2.6-2.6-3.8-4.7-3.8-2 0-3.5 1.2-4.5 3.6-1 2.4-1.5 6.1-1.5 11.2 0 3.8.2 7 .8 9.3.5 2.4 1.2 4.1 2.1 5.1.9 1 2 1.6 3.2 1.6 1.2 0 2.1-.3 2.9-1 .8-.7 1.4-1.7 1.9-3s.8-2.9 1-4.7c.2-1.9.3-3.9.3-6.3ZM221.2 318.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM221.2 80.2c0-.1 0-.1 0 0-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.8 11.7-24.7 26-32.6ZM221.2 239c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.6 26-32.6ZM221.2 159.6c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM116.3 318.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.4-.7 11.8-24.7 26-32.6ZM116.3 80.2c0-.1 0-.1 0 0-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.4-.8 11.8-24.7 26-32.6ZM116.3 239c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.4-.7 11.8-24.6 26-32.6ZM116.3 159.6c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.4-.7 11.8-24.7 26-32.6ZM168.8 278.7c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.8 11.7-24.7 26-32.6ZM168.8 118.3c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.8 11.7-24.7 26-32.6Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="ten-diamonds_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.331 -134.793) scale(574.543)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.331 -134.793) scale(574.543)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.015 367.314) scale(411.698)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.015 367.314) scale(411.698)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.32 .48) scale(457.129)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.32 .48) scale(457.129)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.34 116.294) scale(389.351)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.34 116.294) scale(389.351)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.952 0 0 -456.924 296.428 .478)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-diamonds_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.952 0 0 -456.924 296.428 .478)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgTenDiamonds;
